export const lowerCaseLetterValidatorRegExp = /[a-z]/;
export const lowerCaseLettersValidatorRegExp = /^[a-z]+$/;

export const validateLowerCaseLetter = (
  string: string,
): boolean => lowerCaseLetterValidatorRegExp.test(string);
export const validateLowerCaseLetters = (
  string: string,
): boolean => lowerCaseLettersValidatorRegExp.test(string);
